module.exports = __webpack_public_path__ + "img/guide-04.af7eb664.jpg";